import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "react";
import { FloatLineComponent } from "shared-ui-components/lines/floatLineComponent.js";
import { GetFloatInputBlockEditorData } from "../../../graphSystem/getEditorData.js";
import { FloatSliderComponent } from "../../../sharedComponents/floatSliderComponent.js";
/**
 * The property tab component for InputBlock of type ConnectionPointType.Float.
 * If the animation type is time, display the value and valueDeltaPerMs properties
 * plainly-- no slider capability. Otherwise, display the value alongside
 * optional min and max properties that, when set, toggle a slider for the value.
 */
export class FloatPropertyTabComponent extends Component {
    // eslint-disable-next-line babylonjs/available
    constructor(props) {
        super(props);
        this._processEditorData(true);
    }
    _processEditorData(initializeState = false) {
        // Initialize state data
        const editorData = GetFloatInputBlockEditorData(this.props.inputBlock);
        const state = {
            useTime: editorData.animationType === "time",
        };
        if (initializeState) {
            this.state = state;
            return;
        }
        this.setState(state);
        this.props.stateManager.onUpdateRequiredObservable.notifyObservers(this.props.inputBlock);
    }
    // eslint-disable-next-line babylonjs/available
    componentDidUpdate(prevProps) {
        if (prevProps.inputBlock !== this.props.inputBlock) {
            this._processEditorData();
        }
    }
    // eslint-disable-next-line babylonjs/available
    render() {
        const editorData = GetFloatInputBlockEditorData(this.props.inputBlock);
        return (_jsxs(_Fragment, { children: [!this.state.useTime && (_jsx(FloatLineComponent, { lockObject: this.props.stateManager.lockObject, label: "Min", target: editorData, propertyName: "min", onChange: () => {
                        // Ensure other value gets set
                        editorData.max = editorData.max ?? 0;
                        this._processEditorData();
                    } })), !this.state.useTime && (_jsx(FloatLineComponent, { lockObject: this.props.stateManager.lockObject, label: "Max", target: editorData, propertyName: "max", onChange: () => {
                        // Ensure other value gets set
                        editorData.min = editorData.min ?? 0;
                        this._processEditorData();
                    } })), _jsx(FloatSliderComponent, { lockObject: this.props.stateManager.lockObject, label: this.props.inputBlock.name, target: this.props.inputBlock.runtimeValue, propertyName: "value", min: editorData.min, max: editorData.max, onChange: () => {
                        this.props.stateManager.onUpdateRequiredObservable.notifyObservers(this.props.inputBlock);
                    }, forceSliderOff: this.state.useTime }), this.state.useTime && (_jsx(FloatLineComponent, { lockObject: this.props.stateManager.lockObject, label: "valueDeltaPerMs", target: editorData, propertyName: "valueDeltaPerMs", onChange: () => {
                        this.props.stateManager.onUpdateRequiredObservable.notifyObservers(this.props.inputBlock);
                    } }, this.props.inputBlock.uniqueId))] }));
    }
}
//# sourceMappingURL=floatPropertyTabComponent.js.map